import { render } from "./grayscale.vue?vue&type=template&id=a93f49bc"
import script from "./grayscale.vue?vue&type=script&lang=js"
export * from "./grayscale.vue?vue&type=script&lang=js"

import "./grayscale.vue?vue&type=style&index=0&id=a93f49bc&lang=css"
script.render = render

export default script